export default __webpack_public_path__ + "static/media/hotitworks3.67423d11.svg";